import React from 'react';
import { SupportingDocumentsDisplay } from './SupportingDocumentsDisplay';
import { IContentFileUpload } from '../types';

interface ISupportingDocumentsSectionProps {
  documents: IContentFileUpload[];
  isCreateMode?: boolean;
  onAddDocument: (file: File, displayName: string) => Promise<void>;
  onDeleteDocument: (index: number) => void;
  onDocumentClick?: (index: number) => void;
}

export const SupportingDocumentsSection = ({
  documents,
  isCreateMode = false,
  onAddDocument,
  onDeleteDocument,
  onDocumentClick,
}: ISupportingDocumentsSectionProps) => {
  return (
    <div className="space-y-[10px]">
      {/* Section Title */}
      <span className="font-bold text-[17px] text-gray-800 font-pt-sans">Supporting Documents</span>

      {/* Supporting Documents Display */}
      <SupportingDocumentsDisplay
        documents={documents}
        isCreateMode={isCreateMode}
        onAddDocument={onAddDocument}
        onDeleteDocument={onDeleteDocument}
        onDocumentClick={onDocumentClick}
      />
    </div>
  );
};